export default {
  navbar: {
    Home: "Accueil",
    Dashboard: "Tableau de bord",
    My: "Mon espace",
    Support: "Support",
    Projects: "Projets",
    ProjectCount: "Compte",
    Admin: "Administrateur",
    Library: "Bibliothèque",
    ProjectList: "Liste des projets",
    Profile: "Profil",
    SiteObservation: "Observation sur site",
    GenerateReport: "Générer des rapports",
    BaselineConfig: "Configuration de la ligne de base",
    MonthlyBaseline: "Ligne de base mensuelle",
    EquipmentSpecs: "Caractéristiques des équipements",
    BaselinePreview: "Aperçu de la ligne de base",
    Analysis: "Analyse",
    Menu: "Menu",
    Objective: "Objectif",

    RetrofitSolution: "Solution de retrofit",
    ExistingEqptSpecs: "Caractéristiques des équipements existants",

    Baseline: "Référence",
    Proposed: "Proposé",
    SetupOperatingCondition: "Configurer les conditions de fonctionnement",
    DefineNewEquipment: "Définir un nouvel équipement"
  },

  ctrl: {
    Login: "Connexion",
    Logout: "Déconnexion",
    Register: "Inscription",
    ModifyPassword: "Modifier le mot de passe",
    Language: "Langue",
    UserGuide: "Guide utilisateur",
    UserSetting: "Paramètres utilisateur",
    Delete: "Supprimer",
    Cancel: "Annuler",
    Edit: "Modifier",
    Copy: "Copier",
    Paste: "Coller",
    Proceed: "Continuer",
    Save: "Enregistrer",
    Back: "Retour",
    Next: "Suivant",
    Confirm: "Confirmer",
    Close: "Fermer",
    Exit: "Quitter",
    All: "Tout",
    Clear: "Effacer",
    Yes: "Oui",
    No: "Non",
    Template: "Modèle",
    AddEquipment: "Ajouter un équipement",
    DownloadReport: "Télécharger le rapport",
    MultiInput: "Saisie multipoint",
    AddBaseline: "Ajouter une ligne de base",
    Estimate: "Estimer",
    Calculate: "Calculer le",
    ViewDetail: "Voir les détails",
    CollapseDetail: "Réduire les détails",
    Generate: "Générer",
    Input: "Saisie",
    Reconfigure: "Reconfigurer",
    Optimize: "Optimiser",
    CurrentYear: "Année en cours",
    LastYear: "Année précédente",
    NextYear: "Année suivante",
    Last12Months: "12 derniers mois",
    Next12Months: "12 prochains mois",
    selectClearAll: "Tout sélectionner / Tout effacer",
    View: "Afficher"
  },

  label: {
    ProjectName: "Nom du projet",
    Multiple: "Multiple",
    BuildVertical: "Type de bâtiment",
    DataCollectionMont: "Mois de collecte des données",
    CurrencyLabel: "Devise",
    TemperatureUnit: "Unité de température",
    Unit: "Unité",
    Time: "Temps",
    Hour: "Heure",
    Hours: "Heures",
    Day: "Jour",
    Days: "Jours",
    Month: "Mois",
    Months: "Mois",
    Year: "Année",
    Years: "Années",

    ChillerType: "Type de groupe froid",
    PumpingConfiguration: "Configuration de pompage",
    Primary: "primaire",

    RatedPower: "Puissance nominale",
    RatedInputPower: "Puissance électrique nominale",
    RatedCoolingCapacity: "Capacité frigorifique nominale",
    Frequency: "Fréquence",
    MaxHz: "Fréquence max.",
    MinHz: "Fréquence min.",
    RatedFrequency: "Fréquence nominale",
    MaxFrequency: "Limite supérieure de fréquence de fonctionnement",
    MinFrequency: "Limite inférieure de fréquence de fonctionnement",
    RatedHeatRejectionCapacity: "Capacité de rejet de chaleur nominale",

    VFD: "VFD",
    VariableFrequencyDrive: "Variateur de fréquence",

    AssetLabels: "Étiquettes d’actifs",
    UnitNumber: "Nombre d’unités (#)",
    PumpType: "Type de pompe",
    DateCommissioned: "Date de mise en service",
    Degradation: "Facteur de vieillissement",
    Brand: "Marque",
    Model: "Modèle",
    Remarks: "Remarques",

    RatedInputPower_100: "Puissance électrique nominale",
    RatedInputPower_100_ct: "Puissance électrique nominale par tour de refroidissement",

    RatedCoolingCapacity_100: "Capacité frigorifique nominale",
    RatedHeatRejectionCapacity_100: "Capacité de rejet de chaleur nominale",

    DesignCondenserWaterEnteringTemp: "Temp. d’entrée eau condenseur (conception)",
    TotalCellPerCoolingTower: "Nombre de cellules par tour",
    ActualCondenserWaterEnteringTemp: "Temp. d’entrée eau condenseur (réelle)",
    TotalCellPerDryCooler: "Nombre de cellules par dry cooler",
    DryCoolerType: "Type de dry cooler",
    RatedCapacity: "Capacité nominale",
    EnergyType: "Énergie d’entrée",

    BaselineName: "Nom de la ligne de base",
    ApplicableMonths: "Mois applicables",

    DataTable: "Tableau de données",
    ChartView: "Vue graphique",
    CoolingLoad: "Charge frigorifique",
    Total: "Total",

    Observation: "Observation",
    Photo: "Photo",
    Maximum6: "Maximum 6",

    ChillerConfiguration: "Configuration des groupes froids",
    BoilerConfiguration: "Configuration chaudière",
    CoolingSystemConfiguration: "Configuration du système de refroidissement",

    MaxHeatingCapacity: "Capacité max. (mois le plus froid)",
    EffectiveCapacity: "Capacité effective (mois le plus froid)",
    BoilerEfficiency: "Rendement chaudière",
    hotWaterTemp: "Température requise pour l’eau chaude",

    EnergyCarbonIntensity: "Intensité carbone de l’énergie",
    FuelCalorificValue: "Pouvoir calorifique du combustible (CV)",

    ZeroHeatingOAT: "Température de début de chauffage",
    MaxHeatingOAT: "Température extérieure à chauffage max.",
    DesiredHotWaterTemp: "Température souhaitée d’eau chaude",
    BoilerUtilizationColdestTemp: "Taux d’utilisation chaudière au plus froid",
    ColdestWater: "Température d’eau entrante la plus froide",

    WaterDemandPerDay: "Besoin moyen en eau par personne",
    UserNumber: "Nombre d’occupants",
    liters: "litres",

    ChillerModel: "Modèle de groupe froid",
    RefChillerModel: "Modèle de référence",
    WeatherProfile: "Profil météo",
    EstimatePath: "Chemin d’estimation",
    AvailableData: "Données disponibles",
    CondenserWaterTempProfile: "Profil de temperature de l’eau de condenseur",

    DesignCondenserSupplyTemp: "Temp. départ eau condenseur (conception)",
    DesignCondenserAirSupplyTemp: "Température d'alimentation d'air du condensateur de conception",
    DesignChilledWaterTemp: "Temp. départ eau glacée (conception)",
    OutDoorDryBulbTemp: "Temp. extérieure (bulbe sec)",
    ChilledWaterSupplyTemp: "Temp. départ eau glacée",
    TowerApproachTemp: "Approach tour de refroidissement",
    ActualCondenserSupplyTemp: "Temp. départ eau condenseur réelle",
    ActualCondenserAirSupplyTemp: "Température d'alimentation d'air du condensateur réelle",
    ActualChilledWaterSupplyTemp: "Temp. départ eau glacée réelle",
    MinCondenserWaterSupplyTemp: "Temp. minimale de l'eau d'alimentation du condenseur",
    DesignSourceWaterTemp: "Température de départ de l'eau de source en conditions de conception",
    DesignSourceAirTemp: "Température de l'air de source en conditions de conception",
    DesignHotWaterSupplyTemp: "Température de départ de l'eau chaude en conditions de conception",

    ChillerRunningNumber: "Nombre de groupes froids en service",
    CoolingCapacityRange: "Plage de capacité frigorifique",
    AllRightsReserved: "Tous droits réservés.",

    From: "De",
    To: "À",

    Cluster: "Cluster",
    ClusterNum: "Nombre de clusters",
    ClusterName: "Nom du cluster",
    WeekPeriod: "Période hebdomadaire",
    AssociationMethod: "Méthode d’association",

    MaxCoolingLoadBaseline: "Charge max. (ligne de base)",
    MaxCoolingLoad: "Charge max.",
    AssociatedChiller: "Groupe froid associé",
    MaxRunningNumber: "Nombre max. en service",
    Chiller: "Groupe froid",
    AssociatedHeatPump: "Pompe à chaleur associée",

    RetrofitPreferences: "Préférences de retrofit",

    CAPEX: "CAPEX (Prix du projet, installation incluse)",
    OverallProjectPrice: "Prix total du projet",
    USFXRate: "Taux de change USD",

    Option: "Option",
    Solution: "Solution",

    GeneralInfo: "Informations générales",
    TechSpec: "Spécification technique",
    PerformanceConditions: "Conditions de performance",
    EcatPerformanceInput: "Saisie des performances e-CAT",
    Capacity: "Capacité",
    CoolingCapacity: "Puissance frigorifique",
    SerialNumber: "Numéro de série",
    ElectricalLoad: "Charge électrique",

    Category: "Catégorie",
    EfficiencyImprovement: "Amélioration d’efficacité",
    CostSavingsPerYear: "Économies annuelles",
    ROI: "Retour sur investissement",
    PaybackPeriod: "Délai de récupération actualisé",
    SimplePayback: "Délai de retour simple",

    Estimated: "Estimé",
    Actual: "Réel",

    Like: "J’aime",
    Dislike: "Je n’aime pas",

    OptionDetails: "Détails de l’option",
    TotalEnergySavings: "Économies d’énergie annuelles",
    RetrofitCost: "Coût de retrofit",
    ExpectedYears: "Durée du cycle de vie de l'actif",
    NPV: "Valeur actuelle nette",

    ProjectIntroduction: "Présentation du projet",
    Assumptions: "Hypothèses",
    AssumptionsConsider: "Hypothèses utilisées pour l’analyse",
    AssumptionsAnalysis: "Hypothèses pour l'analyse",

    ChillerPlant: "Centrale de production de froid",
    Configuration: "Configuration",
    PeakBuildingLoad: "Charge frigorifique de pointe",
    OAT: "Température extérieure (OAT)",
    EnergyConservationMeasures: "Mesures d’économie d’énergie (ECM)",

    DesignFlowRate: "Débit de conception",
    RatedDesignFlowRate: "Débit nominal (conception)",
    DesignPressureHead: "HMT de conception",
    PressureHead: "HMT",
    VFDFitted: "VFD installé",

    DesignConditions: "Conditions de conception",
    ProjectSettings: "Paramètres du projet",

    Tariff: "Tarif",
    EnergyTariff: "Tarif énergétique",
    MonthlyTariff: "Tarif mensuel",
    OperatingPeriod: "Période d’exploitation",
    RunningMonths: "Mois d’exploitation",

    Recommendation: "Recommandation",
    Benefit: "Bénéfice",

    MonthlyRunningDays: "Jours d’exploitation ({type})",
    BaselineMonth: "Mois de référence",
    EstimatedMonth: "Mois estimé",
    EstimatedPower: "Puissance estimée",
    ElectricityCarbonIntensity: "Intensité carbone de l’électricité",
    PlantEfficiency: "Efficacité de la centrale",
    EfficienctyUnit: "Unité d’efficacité",

    Type: "Type",
    SellingPricePrtUnit: "Prix de vente par unité",
    ApplicableChiller: "Groupe froid applicable",
    NoOfFansCT: "Nb de ventilateurs / tour",

    Load: "Charge",
    Power: "Puissance",
    InputPower: "Puissance absorbée",

    TotalEnergyImprovement: "Amélioration énergétique totale",
    EquipmentStatus: "État de l’équipement",

    SetRecommended: "Définir comme recommandé",
    CancelRecommendation: "Annuler la recommandation",

    Optional: "Optionnel",

    RetrofitCostConfiguration: "Configuration des coûts de retrofit",
    PaybackPeriodSummaryNPV: "Résumé temps de retour & NPV",

    EquipmentDetailsProposed: "Détails des équipements proposés",
    GenerateECMReport: "Générer le rapport ECM",

    PeakMaxCoolingLoad: "Charge max. (heures pleines)",
    OffPeakMaxCoolingLoad: "Charge max. (heures creuses)",

    ProposedCoolingCapacity: "Capacité frigorifique proposée",

    ChillerPlantTotal: "Total centrale",

    EnergySavingsPerYear: "Économies d’énergie par an",

    CapitalAssetRetrofitInvestmentCost: "Investissement retrofit (CAPEX)",
    EstimatedProjectValue: "Valeur projet estimée",
    ActualProjectValue: "Valeur projet réelle",

    ProjectDetails: "Détails du projet",

    ElectricalDB: "Tableau électrique",
    PlantControlSys: "Système de contrôle",

    QuickSelect: "Sélection rapide",
    ClusterMonth: "Mois du cluster",

    MonthlyCoolingLoad: "Charge mensuelle",
    MonthlyPower: "Puissance mensuelle",

    Default: "Par défaut",
    ReconfigureSolution: "Reconfigurer la solution",
    ReconfiguredSolution: "Solution reconfigurée",

    SingleChilledWaterTemp: "Temp. unique eau glacée",
    ECatPerformanceData: "Données eCAT",
    CopyInputECATPerformance: "Copier la saisie eCAT",

    CopyFrom: "Copier depuis",
    PasteInto: "Coller dans",

    PredictedUtilization: "Utilisation prédite",
    UserConfirmedUtilization: "Utilisation confirmée",

    ProjectObjective: "Objectif du projet",
    ChillerEfficiency: "Efficacité groupe froid",
    ChillerPlantEfficiency: "Efficacité de la centrale",
    HeatingEfficiency: "Efficacité chauffage",
    HeatingPlantEfficiency: "Efficacité installation chauffage",
    ChillerHeatingEfficiency: "Efficacité froid & chauffage",
    ChillerRetrofit: "Rétrofit du groupe froid",
    ChillerPlantRetrofit: "Rétrofit de la centrale froide",
    HeatingElectricRetrofit: "Modernización de caldera a bomba de calor",
    HeatPumpRetrofit: "Rétrofit de la pompe à chaleur",
    IntegratedRetrofit: "Rétrofit intégré de la centrale froide et chauffage",

    ManualInput: "Saisie manuelle",
    AutoSoon: "Bientôt automatique",

    AvailableDesignTemp: "Température de conception disponible",
    ChillerSelection: "Sélection du groupe froid",
    NewChillerSeries: "Nouvelle série de groupes froids",
    ECATLibraryType: "Type de bibliothèque E-CAT",
    PerformanceTable: "Tableau de performance",
    ChillerName: "Nom du groupe froid",
    StandardECAT: "E-CAT standard",
    EstimatedECAT: "E-CAT estimé",
    CustomizedECAT: "E-CAT personnalisé",
    CustomCapacity: "Capacité personnalisée",

    OperatingDayType: "Type de jour d’exploitation",
    MonthlyOperatingDays: "Nombre de jours d’exploitation mensuels",
    OperatingSiteChiller: "Groupe frigorifique en fonctionnement sur site",
    ProxyChillerModel: "Modèle de groupe frigorifique de référence",
    ManufacturingRegion: "Région de fabrication",
    CompressorType: "Type de compresseur",
    BearingType: "Type de palier",
    VFDType: "Type de variateur de fréquence",
    AvailableProxyModels: "Modèles de référence disponibles",
    NominalCapacity: "Puissance frigorifique nominale",
    PointsCalibration_4: "Étalonnage à 4 points",
    PartLoadCalibration_note: "Seules les données aux conditions de conception usine sont prises en charge pour l’étalonnage à charge partielle.",

    HourlyChillerOperation: "Fonctionnement horaire du groupe frigorifique",
    OperatingChillerCount: "Nombre de groupes frigorifiques en fonctionnement",
    LoadRatio: "Taux de charge",
    CalculatedOperatingLoad: "Charge de fonctionnement calculée",

    NewChillerType: "Type de nouveau groupe frigorifique",

    ProposedEfficiency: "Efficacité proposée",
    RetrofitConfiguration: "Configuration de rénovation",
    ROI_NPVSummary: "Synthèse ROI et VAN",
    AssumptionOfferings: "Hypothèses et offres",

    ProposedRunningNumber: "Nombre proposé d’équipements en fonctionnement",

    ProposedSummary: "Résumé du proposé",
    BaselineEfficiency: "Efficacité de référence",
    AnnualizedAverageROI: "ROI annuel moyen basé sur la VAN",

    SelectProposedScenarios: "Sélectionner les scénarios proposés",
    BaselineHourlyCoolingLoad: "Charge de refroidissement horaire de référence",

    ProxyChillerFilter: "Filtrer le groupe frigorifique de référence",

    ChillerEfficiency_100: "Rendement du groupe frigorifique à 100 % de charge",
    DegradedEfficiency_100: "Rendement dégradé à 100 % de charge",

    CommercialInput: "Données commerciales",

    SiteSettings: "Paramètres du site",
    ExistingBoilerSystem: "Système de chaudière existant",
    HeatingApplication: "Application de chauffage",

    PerformanceModel: "Modèle de performance",
    HeatingCapacityPerUnit: "Capacité de chauffage nominale par unité",
    BaselineSetup: "Configuration de référence",
    OperatingMonths: "Mois de fonctionnement",
    OperatingBoiler: "Chaudière en fonctionnement",
    BoilerNumAtColdest: "Nombre de chaudières en fonctionnement à la température la plus basse",
    singlePriceNote: "Utilisé pour estimer le CAPEX du projet (installation comprise).",

    BoilerDetails: "Détails du système de chaudière",
    HeatPumpCfg: "Configuration de la pompe à chaleur",
    HeatPumpSourceType: "Type de source de la pompe à chaleur",
    HotWaterSupplyTemp: "Température du circuit d’eau chaude",
    ActualHWSTemp: "Température réelle du circuit d’eau chaude",
    SingleHWSTemp: "Température individuelle du circuit d’eau chaude",
    WaterSourceTemp: "Température de la source d’eau",
    GroundLoop: "Circuit géothermique",
    HeatingCapacity: "Capacité de chauffage",
    RatedHeatingCapacity: "Capacité de chauffage nominale",
    HeatPumpSelection: "Sélection de la pompe à chaleur",
    HeatPumpName: "Nom de la pompe à chaleur",
    HeatPumpModel: "Modèle de la pompe à chaleur",
    ModelNumber: "Numéro de modèle",
    AirSourceTemp: "Température de la source d’air",
    DesignAirSourceTemp: "Température de conception de la source d’air",
    DesignEWSTemp: "Température de conception du circuit d’eau de l’évaporateur",
    RatedCOP_100: "COP nominal à 100 %",

    ProposedHeatPumpCOP: "COP proposé de la pompe à chaleur",
    MaxHeatingLoad: "Charge maximale de chauffage",
    ProposedHeatPumpCapacity: "Capacité proposée de la pompe à chaleur par unité",
    CostAssumptionInputs: "Entrées de coûts et hypothèses",
    ExistingAnnualCost: "Coût annuel existant",
    ProposedAnnualCost: "Coût annuel proposé",
    Escalation: "Escalation des coûts"
  },

  option: {
    New: "Nouveau",
    Existing: "Existant",
    Remove: "Supprimer",

    LARGE_OFFICE: "Grand bureau",
    MEDIUM_OFFICE: "Bureau moyen",
    SMALL_OFFICE: "Petit bureau",
    RESTAURANT: "Restaurant",
    HOSPITAL: "Hôpital",
    HOTEL: "Hôtel",
    MALL: "Centre commercial",
    SCHOOL: "École",
    EDUCATIONAL_INSTITUTIONS: "Établissements d’enseignement",
    RESIDENTIAL: "Résidentiel",
    OTHERS: "Autres",

    Month: "Mois",
    Jan: "Jan",
    Feb: "Fév",
    Mar: "Mar",
    Apr: "Avr",
    May: "Mai",
    Jun: "Juin",
    Jul: "Juil",
    Aug: "Août",
    Sep: "Sep",
    Oct: "Oct",
    Nov: "Nov",
    Dec: "Déc",

    plant: "Centrale de froid",
    chiller: "Groupe froid",
    pump: "Pompe",
    coolingTower: "Tour de refroidissement",
    piping: "Tuyauterie",
    dryCooler: "Refroidisseur à sec",
    controlSys: "Système de contrôle",
    boiler: "Chaudière",
    heatPump: "Pompe à chaleur",
    other: "Autre",

    WaterCooled: "Refroidi par eau",
    AirCooled: "Refroidi par air",
    WaterCooled_AirCooled: "Refroidi par eau & air",

    chwp: "Pompe eau glacée",
    chwpPrimary: "Pompe eau glacée - primaire",
    chwpSecondary: "Pompe eau glacée - secondaire",
    PrimaryPump: "Pompe primaire",
    SecondaryPump: "Pompe secondaire",
    cwp: "Pompe eau condenseur",
    CondenserWater: "Eau condenseur",
    ChilledWaterPrimary: "Système eau glacée primaire",
    ChilledWaterPrimarySecondary: "Système eau glacée primaire-secondaire",
    CondenserWaterSys: "Système eau condenseur",
    CommonHeader: "Collecteur commun",
    Dedicated_1_1: "Dédié 1-1",

    wcCentri: "Eau - centrifuge",
    wcScrew: "Eau - vis",
    wcRecip: "Eau - alternatif",
    wcScroll: "Eau - scroll",
    acScrew: "Air - vis",
    acScroll: "Air - scroll",
    acRecip: "Air - alternatif",

    Centrifugal: "Centrífuge",
    Screw: "vis",
    Scroll: "Faites défiler",
    Reciprocating: "réciproque",
    Rotary: "Rotatif",

    Degradation_25: "0,25% / an",
    Degradation_50: "0,50% / an",
    Degradation_75: "0,75% / an",
    Degradation_100: "1,00% / an",

    GoodCondition: "Bon état",
    AverageCondition: "État moyen",
    BelowAverageCondition: "État inférieur à la moyenne",
    BadCondition: "Mauvais état",

    SpaceCooling: "Refroidissement des espaces",
    SpaceHeating: "Chauffage des espaces",
    DomesticHotWater: "Eau chaude sanitaire",
    SHandDHW: "Chauffage des espaces & eau chaude sanitaire",

    GasFuel: "Gaz",
    LiquidFuel: "Carburant liquide",
    ElectricalEnergy: "Électricité",

    DryBulbTemp: "Temp. moyenne bulbe sec",
    WetBulbTemp: "Temp. moyenne bulbe humide",
    WaterTemp: "Température de l'eau",

    MaxDryBulbTemp: "Temp. sèche max",
    MinDryBulbTemp: "Temp. sèche min",
    AvgDryBulbTemp: "Temp. sèche moy",
    MaxWetBulbTemp: "Temp. humide max",
    MinWetBulbTemp: "Temp. humide min",
    AvgWetBulbTemp: "Temp. humide moy",

    PeakWaterTemp: "Temp. eau (pleines)",
    OffPeakWaterTemp: "Temp. eau (creuses)",
    AvgTemp: "Température moyenne",

    ColdWaterTemp: "Temp. eau entrante",

    CondenserWaterSupplyTemp: "Temp. départ eau condenseur",
    MeanCondenserWaterSupplyTemp: "Temp. moy. départ eau condenseur",
    MeanMaxCWSTemp: "Temp. max. moy. départ eau condenseur",
    MeanAvgCWSTemp: "Temp. moy. départ eau condenseur",

    CondenserAirSupplyTemp: "Temp. départ air condenseur",
    MeanCondenserAirSupplyTemp: "Temp. moy. départ air condenseur",
    MeanMaxCASTemp: "Temp. max. moy. départ air condenseur",
    MeanAvgCASTemp: "Temp. moy. départ air condenseur",

    PathA: "Basé sur la charge frigorifique",
    PathB: "Basé sur la consommation d’énergie",
    Method1: "Profil horaire 1 mois",
    Method3: "Profil horaire 12 mois",

    HeatingPathA: "Approche charge chaudière uniquement",
    HeatingPathB: "Charge chaudière + données d’énergie",

    Off: "Arrêt",
    Peak: "Pleine",
    OffPeak: "Creuse",
    AllPeak: "Tout pleine",
    PeakPeriod: "Période pleine",
    OffPeakPeriod: "Période creuse",
    WeekdayPeak: "Semaine pleine",
    WeekdayOffPeak: "Semaine creuse",
    WeekendPeak: "Week-end pleine",
    WeekendOffPeak: "Week-end creuse",

    AllCity: "Toutes les villes",
    MegaCity: "Mégapole",
    NonMegaCity: "Hors mégapole",

    Win: "Gagné",
    PipeLine: "En cours",
    TotalPipeline: "Pipeline total",
    ActualOrder: "Commande réelle",
    ExpectedOrder: "Commande prévue",

    All: "Tout",
    Values: "Valeurs",
    Projects: "Projets",
    Count: "Compte",
    WinProbability: "Probabilité de gain",

    SingleCluster: "Cluster unique",
    MultipleCLuster: "Clusters multiples",

    HighestEfficiencyImprovement: "Meilleure amélioration d’efficacité",
    LowestInvestment: "Investissement le plus faible",
    ShortestPaybackPeriod: "Temps de retour le plus court",

    Max: "Max",
    Min: "Min",
    Avg: "Moy",

    StepMonthlyCoolingLoad: "Charge mensuelle",
    StepEstimateCoolingLoad: "Estimer la charge",
    StepEstimatePower: "Estimer la puissance du groupe froid",
    StepEstimatePowerLoad: "Estimer la puissance du groupe froid",
    EstimateChillerCount: "Nombre estimé de groupes frigorifiques",

    OperatingCalendar: "Calendrier d’exploitation",
    OperatingHours: "Heures de fonctionnement",
    OperatingLoad: "Charge de fonctionnement",
    ReferChiller: "Groupe froid de référence",
    MonthlyChillerCount: "Nombre mensuel de groupes frigorifiques",

    RunningHours: "Heures de fonctionnement",
    EnergyConsumption: "Consommation d’énergie",
    ChillerEnergyConsumption: "Consommation énergétique du groupe froid",

    AuxiliaryPower: "Puissance auxiliaire",
    PlantEquipment: "Équipements de la centrale",
    ChillerPower: "Puissance du groupe froid",
    CHWPPower: "Puissance pompe eau glacée",
    CWPPower: "Puissance pompe eau condenseur",
    CTPower: "Puissance tour de refroidissement",

    WeightedAvgEfficiency: "Efficacité moyenne pondérée",
    WeightedAvgCoolingLoad: "Charge moyenne pondérée",
    WeightAvgPower: "Puissance moyenne pondérée",
    RunningHrsPerDay: "Heures de fonctionnement/jour",
    ActualWeightedAveragePower: "Puissance moyenne pondérée réelle",

    AnnualCost: "Coût annuel",
    AnnualEscalation: "Escalade annuelle",
    IncentiveRebate: "Incitation & rabais",

    ProposeConfig: "Configuration proposée",

    Weekday: "Semaine",
    Weekend: "Week-end",
    WholeWeek: "Toute la semaine",

    Automatic: "Automatique",
    Manual: "Manuel",
    Reconfigured: "Reconfiguré",
    AlgorithmSelectsConfig: "L’algorithme sélectionne la config.",
    UserSelectsConfig: "L’utilisateur sélectionne la config.",

    ManualCluster: "Cluster manuel",
    DigitalECAT: "eCAT numérique",

    BoilerUtilization: "Taux d’utilisation chaudière",
    HeatingLoad: "Charge de chauffage",
    MonthlyHeatingLoad: "Charge mensuelle de chauffage",
    EffectiveMonthly: "Énergie mensuelle effective",
    EnergyCharges: "Coûts d’énergie",
    CO2Emissions: "Émissions de CO₂",
    GasFuelConsumption: "Consommation de carburant gazeux",
    LiquidFuelConsumption: "Consommation de carburant liquide",
    ElectricalEnergyConsumption: "Consommation d'énergie électrique",
    GasFuelCharges: "Frais de carburant gazeux",
    LiquidFuelCharges: "Frais de carburant liquide",
    ElectricalEnergyCharges: "Frais d'énergie électrique",

    Standard: "Standard",
    Ceramic: "Céramique",
    Magnetic: "Magnétique",
    VFD: "Variateur de fréquence",
    NonVFD: "Sans variateur de fréquence",
    ClusterMonths: "Mois regroupés",

    Chiller: "Groupe froid",
    HeatPump: "Pompe à chaleur",
    WaterSource: "À source d'eau",
    AirSource: "À source d'air",

    ConstantEfficiency: "Efficacité constante",
    UserDefinedCurve: "Courbe définie par l’utilisateur",
    BoilerOperation: "Fonctionnement de la chaudière",
    MonthlyEnergyConsumption: "Consommation mensuelle d'énergie",
    AvgHeatingLoad: "Charge de chauffage moyenne pondérée",
    MonthlyBoilerCount: "Nombre mensuel de chaudières",
    BoilerEnergyConsumption: "Consommation d'énergie de la chaudière",
    EstimateBoilerCount: "Nombre estimé de chaudières",
    EstimateHeatingLoad: "Charge de chauffage estimée",
    EstimateEnergyConsumption: "Estimer la consommation d'énergie",

    ECatLib: "Bibliothèque e-CAT",
    OwnLib: "Bibliothèque propre"
  },

  msg: {
    imageOnly: "Seuls les fichiers image sont autorisés",
    comingSoon: "Bientôt disponible.",
    Success: "Succès",
    FailedRetry: "Échec ! Veuillez réessayer",
    DeleteEquip: "Supprimer l’équipement",
    DeleteWarning: "Confirmez-vous la suppression : ",
    DeleteBaseline: "Supprimer la ligne de base",
    Warning: "Avertissement",
    UnsavedWarning: "Les modifications non enregistrées seront perdues si vous quittez cette page.",
    SaveBeforeProceeding: "Souhaitez-vous enregistrer avant de continuer ?",
    NoOptionsSelected: "Aucune option sélectionnée",
    AlreadyExists: "Existe déjà",
    Saving: "Enregistrement...",
    Generating: "Génération...",
    Loading: "Chargement...",
    DeletingFiles: "Suppression des fichiers...",
    CompressingFiles: "Compression des fichiers...",
    UnsupportedImageTypeTitle: "Fichiers non pris en charge ignorés",
    UnsupportedImageTypesDiscarded: "Types de fichiers ignorés",
    UploadingFiles: "Téléversement des fichiers...",
    NetworkError: "Anomalie réseau, opération échouée",
    NetworkLimit: "Anomalie réseau, fonction limitée",
    Over24HoursTips: "Durée totale supérieure à 24 heures",
    Over24HoursToast: "La somme pleines/creuses ne doit pas dépasser 24 heures",
    CityChanged: "La ville est passée de {curtCity} à {newCity}.",
    OverrideWeatherData: "<br>Souhaitez-vous remplacer le profil météo existant par l’OAT de la ville sélectionnée ?",
    ProjectNameIsEmpty: "Le nom du projet ne peut pas être vide",
    CityIsEmpty: "La ville ne peut pas être vide",
    SelectReferModel: "Veuillez sélectionner un modèle de référence",
    InputDataIntoReferenceChiller: "Saisissez les données ci-dessus dans le groupe froid de référence",
    PeriodCanNotAllOff: "La période ne peut pas être entièrement à l’arrêt",
    CanNotBlank: "Ne peut pas être vide",
    CanNotBlankZero: "Ne peut pas être vide ou 0",
    CanNotAllBlank: "Ne peut pas être entièrement vide",
    CanNotAllBlankZero: "Ne peut pas être entièrement vide ou entièrement à 0",
    NetworkTimeout: "Délai réseau dépassé ! Veuillez réessayer",
    RequestError: "Erreur de requête",
    LoginExpired: "Session expirée",
    AccessDenied: "Accès refusé",
    ResourceNotExist: "La ressource demandée n’existe pas",
    ServerError: "Erreur de service",
    GatewayError: "Erreur de passerelle",
    ServiceUnavailable: "Service indisponible",
    UserNotExist: "L’utilisateur n’existe pas",
    WrongPassword: "Mot de passe incorrect",
    NotActivate: "Compte non activé",
    DeleteCluster: "Supprimer le cluster",
    Estimating: "Estimation...",
    Analyzing: "Analyse...",
    Calculating: "Calcul...",
    UnsavedAfterEstimate: "Les données non enregistrées saisies après la dernière estimation seront perdues si vous quittez cette page.",
    DiscountRateTips: "Le taux d’actualisation détermine le rendement attendu ; à défaut, le taux d’inflation est appliqué.",
    CalculateROINotice: "Veuillez d’abord cliquer sur « 1. Saisie » pour compléter le coût de retrofit, puis sur « Calculer le ROI ».",
    ConfirmFxRate: "Veuillez confirmer le taux de change USD",
    SetRecommended: "Définir {name} comme recommandé",
    SelectCardPasteInto: "Veuillez sélectionner la carte dans laquelle coller.",
    Copied: "Copié dans le presse-papiers",
    Pasted: "Collé",
    OverwriteOption: "La régénération écrasera toutes les données de solution existantes et supprimera le rapport généré.",
    OverwriteOptionAll: "Vous avez configuré une solution optimisée. <br/>La régénération écrasera toutes les données de solution existantes et supprimera le rapport généré.",
    RefreshRequired: "Actualisation requise",
    ReAnalysisPre:
      "Pour générer ou mettre à jour l’aperçu de la Baseline, actualisez d’abord l’analyse de la charge frigorifique et de la puissance dans la Baseline mensuelle, puis actualisez manuellement l’aperçu de la Baseline.",
    ReAnalysisHeating:
      "Pour générer ou mettre à jour l'Aperçu de référence, actualisez d'abord l'Analyse de charge de chauffage et de puissance dans la ligne de base mensuelle, puis actualisez manuellement l'Aperçu de référence.",

    PleaseSelectObjective: "Veuillez sélectionner un objectif",
    HeatingOnlySupportsPre: "Le module d’efficacité chauffage ne prend en charge que l’étape avant retrofit",
    CompleteBaselineConfigFirst: "Veuillez d’abord terminer la configuration de la ligne de base (avant retrofit).",
    CompleteBaselineAnalysisFirst: "Veuillez d’abord terminer l’analyse de la ligne de base (avant retrofit).",

    AcceptOneUtilization: "Accepter Utilisation prédite comme Utilisation confirmée par l'utilisateur ?",
    AcceptAllUtilization: "Accepter toute l'Utilisation prédite comme Utilisation confirmée par l'utilisateur ?",
    NoReportGenerate: "Aucun rapport, veuillez entrer le projet à générer.",

    DependencyHint: "Indication de dépendance :",
    DryBulbDependencyCooling: "La température de bulbe sec est utilisée pour estimer le profil de charge frigorifique.",
    WeatherDependencyCooling:
      "Pour les groupes frigorifiques refroidis par eau, la température d’alimentation en eau du condenseur est utilisée pour estimer la consommation électrique du groupe frigorifique. Pour les groupes frigorifiques refroidis par air, la température de bulbe sec est utilisée à la place.",

    DryBulbDependencyHeating:
      "La température de bulbe sec est utilisée pour estimer le profil de charge du chauffage des locaux, tandis que la température d’entrée de l’eau froide est utilisée pour estimer le profil de charge de l’eau chaude sanitaire.",
    WeatherDependencyHeating: "Les paramètres météorologiques affichés ci-dessus dépendent de l’application de chauffage sélectionnée.",

    CalibrationTitle: "Données d’étalonnage à 4 points incomplètes",
    CalibrationNote:
      "Les données d’étalonnage à 4 points du groupe frigorifique de référence sont incomplètes. Saisissez les valeurs correspondant aux quatre points de charge (25 %, 50 %, 75 % et 100 %), ou désactivez l’étalonnage à 4 points pour continuer.",
    CalibrationBack: "Retour au groupe frigorifique de référence",

    SelectReportingFocus: "Sélectionner l’orientation du rapport client",
    ROILedSummary: "Résumé axé sur le ROI",
    EfficiencyLedSummary: "Résumé axé sur l’amélioration de l’efficacité",
    ROILedNote: "À utiliser lorsque l'investissement, les économies et le retour sur investissement sont suffisants pour justifier le projet.",
    EfficiencyLedNote: "À utiliser lorsque l'amélioration de l'efficacité est la principale justification, indépendamment de l'attractivité du retour sur investissement.",
    ROILedNote_C: "À utiliser lorsque les coûts d’investissement, les économies réalisées et la période de retour sur investissement sont disponibles.",
    EfficiencyLedNote_C: "À utiliser lorsque la décision repose principalement sur l’amélioration de l’efficacité énergétique ou lorsque les données de ROI ne sont pas disponibles ou pertinentes.",

    ImgIgnoredWhenOffline: "Les opérations d’image seront ignorées lorsque vous êtes hors ligne"
  },

  placeholder: {
    PleaseInput: "Veuillez saisir",
    SearchHere: "Rechercher ici",
    PleaseSelect: "Veuillez sélectionner",
    SearchFilter: "Rechercher & Filtrer",
    NotAvailable: "Non disponible",
    NoDataExist: "Aucune donnée",
    NoDataAvailable: "Aucune donnée disponible",
    NoChillerExist: "Aucune donnée de groupe froid",
    NoBaselineExist: "Aucune donnée de ligne de base",
    ClusterAutomaticallyMatches: "Associer automatiquement toutes les périodes d’exploitation",
    NoClusterExist: "Aucun mois de cluster, veuillez d’abord définir les mois",
    SelectTempCluster: "Veuillez sélectionner la température du cluster",
    PleaseSelectInputFormat: "Veuillez sélectionner ou saisir, format : ",
    SearchFormat: "Rechercher le format : ",
    DigitalECatNotify: "Les données eCAT numériques sont en cours d’intégration. Utilisez le cluster manuel pour l’instant",

    AssumptionsPlaceholder:
      "Veuillez décrire les hypothèses utilisées pour l'analyse. Précisez les conditions météorologiques prises en compte, le profil mensuel des équipements utilisés et les données clients communiquées lors de l'entretien. Vous pouvez également utiliser le bouton Modèle pour obtenir une description standard.",
    AssumptionsTemp:
      "La présente analyse s’appuie sur [données de consommation énergétique des groupes froids / données de charge de refroidissement], estimées à partir d’entretiens d’exploitation. Ces données sont utilisées pour estimer la performance mensuelle à charge partielle (part-load) du groupe froid existant [Renseigner le modèle de groupe froid], en la corrélant aux données météorologiques historiques locales sur la période correspondante.\n\n\
(Optionnel : à utiliser si la consommation des groupes froids est exprimée comme un pourcentage de l’énergie totale du bâtiment)\n\
Contribution énergétique de la production de froid :\n\
La consommation énergétique de la centrale de froid (chiller plant) est supposée représenter [Renseigner le pourcentage, p. ex. 45 %] de la consommation énergétique totale du bâtiment.\n\n\
Les paramètres d’exploitation ci-dessous, confirmés avec l’équipe du client, ont été utilisés :\n\
Calendrier d’exploitation des groupes froids :\n\
[Nombre] groupe(s) froid(s) fonctionne(nt) de [Mois] à [Mois].\n\
[Nombre] groupe(s) froid(s) fonctionne(nt) de [Mois] à [Mois].",

    ObservationNote: "Conservez uniquement les options entre crochets applicables et vérifiez toutes les informations du site avant d’enregistrer.",
    Observation_chiller:
      "Le groupe frigorifique existant montre des signes de vieillissement et une efficacité réduite. Le site signale [alarmes fréquentes / forte consommation / fonctionnement instable / maintenance accrue], surtout à [charge partielle / pointe].",
    Recommendation_chiller:
      "Réaliser un essai de performance et vérifier les consignes, le fluide frigorigène, les échangeurs et la régulation. Selon les résultats, optimiser le fonctionnement ou remplacer l’unité par un groupe à haut rendement et vitesse variable.",
    Benefit_chiller:
      "Les bénéfices attendus comprennent une baisse de la consommation, un meilleur rendement à charge partielle, moins d’arrêts imprévus, des coûts de maintenance réduits et une production d’eau glacée plus stable. Un remplacement performant peut aussi réduire les émissions et améliorer la fiabilité à long terme.",
    Observation_pump:
      "La pompe [d’eau glacée / d’eau condenseur] fonctionne à [vitesse fixe / un point peu efficace]. Le débit paraît excessif à charge partielle et [bruit / vibrations / fuite / pression instable] a été observé.",
    Recommendation_pump:
      "Vérifier le point de fonctionnement, le débit, la hauteur, les vannes et l’équilibrage. Remettre en service la pompe et la régulation. Si possible, activer un variateur et ajuster la vitesse selon la pression différentielle ou la demande.",
    Benefit_pump:
      "La mesure peut réduire l’énergie de pompage, les surdébits et les pertes d’étranglement, améliorer le delta T et la stabilité hydraulique, et limiter l’usure. Un fonctionnement selon la demande peut aussi réduire la maintenance et améliorer l’efficacité globale de la centrale.",
    Observation_coolingTower:
      "La tour présente [approche élevée / garnissage encrassé / distribution d’eau inégale / mauvaise régulation des ventilateurs / tartre visible]. La température d’eau condenseur n’est pas maintenue à un niveau efficace.",
    Recommendation_coolingTower:
      "Inspecter et nettoyer le garnissage, le bassin, les buses, filtres et surfaces d’échange. Vérifier le traitement d’eau, l’air et les ventilateurs. Optimiser les étages et la variation de vitesse pour maintenir la température requise.",
    Benefit_coolingTower:
      "Une meilleure performance peut abaisser la température d’eau condenseur dans les limites sûres, réduire la pression de condensation et l’énergie du groupe, stabiliser la centrale et limiter tartre ou corrosion. La régulation des ventilateurs peut aussi économiser de l’énergie et prolonger la durée de vie.",
    Observation_controlSys:
      "Le système de contrôle assure surtout une surveillance de base sans optimiser la séquence des groupes, pompes et tours. Les consignes et étages sont [fixes / réglés manuellement / non coordonnés avec la charge].",
    Recommendation_controlSys:
      "Moderniser ou remettre en service la régulation avec séquencement selon la demande, réinitialisation des consignes, étagement, gestion des alarmes et suivi des performances. Étalonner les capteurs clés de température, pression, débit et puissance.",
    Benefit_controlSys:
      "Une régulation coordonnée peut améliorer l’efficacité globale en pilotant groupes, pompes et tours comme un seul système. Elle peut réduire les heures inutiles, stabiliser températures et débits, améliorer la visibilité des défauts et permettre un suivi continu des performances et de l’énergie.",
    Observation_dryCooler:
      "Le refroidisseur sec présente [batteries encrassées / débit d’air limité / ailettes endommagées / température de sortie élevée / mauvaise régulation]. Les ventilateurs sont [à vitesse fixe / instables] et le rejet de chaleur paraît insuffisant à [charge partielle / pointe].",
    Recommendation_dryCooler:
      "Inspecter et nettoyer les batteries, redresser les ailettes et supprimer les obstacles à l’air. Vérifier le débit, le sens des ventilateurs, les capteurs et la régulation. Optimiser les étages ou la vitesse selon la température de sortie et la demande.",
    Benefit_dryCooler:
      "Une meilleure performance peut réduire la température du fluide, améliorer le rejet de chaleur et diminuer l’énergie des ventilateurs et du groupe. Une régulation optimisée réduit les heures et le bruit; l’entretien des batteries maintient la capacité, la stabilité et la durée de vie.",
    Observation_boiler:
      "La chaudière existante assure [le chauffage des locaux/l'ECS]. La chaudière fonctionne avec [type de combustible] et présente [une consommation de combustible élevée/des cycles fréquents/une température de départ élevée/une inefficacité de combustion/des fuites]. Surveillance ou optimisation basée sur la charge limitée constatée.",
    Recommendation_boiler:
      "Évaluez la charge de chauffage, la température de départ d'eau, le programme de fonctionnement et les exigences des unités terminales. Évaluez l'adéquation de la pompe à chaleur et déterminez si la chaudière doit être conservée pour le fonctionnement en pointe ou en secours.",
    Benefit_boiler:
      "L'intégration d'une pompe à chaleur peut réduire la consommation de combustible, les émissions de carbone et les coûts d'exploitation tout en maintenant la performance de chauffage requise. Un bon ajustement de la charge améliore l'efficacité saisonnière et peut réduire la dépendance à la combustion d'énergies fossiles. Conserver les chaudières existantes uniquement pour la pointe ou le secours permet de minimiser le risque de rénovation tout en soutenant les objectifs de décarbonation."
  },

  param: {
    hr: "Temps",
    period: "Période",
    chCount: "Nombre de groupes froids en service",
    maxLoad: "Charge nominale max.",
    percent: "Charge d’exploitation",
    capacity: "Charge totale en service",
    consumption: "Consommation d’énergie",
    existing: "Existant",
    proposed: "Proposé",
    assumptions: "Hypothèses",
    energy: "Énergie",
    maintenance: "Maintenance",
    repair: "Réparation",
    other: "Autres",
    discountRate: "Taux d’actualisation"
  },

  wizard: {
    navbar: {
      Wizard: "Assistant",
      MinimumInput: "Configuration rapide",
      GenerateDefaults: "Générer les valeurs par défaut initiales",
      ReviewAssumptions: "Vérifier les hypothèses",
      RunQuickCalculation: "Lancer le calcul rapide",
      ProposedSolution: "Résultats de l’évaluation"
    },
    label: {
      ActualConditions: "Conditions réelles",
      MonthlyAverageTariff: "Tarif moyen mensuel",
      YearlyEnergyBill: "Facture énergétique annuelle",
      ReviewSection: "Section de vérification",
      CoolingApplication: "Type d’application de refroidissement",
      TemperatureSensitivityFactor: "Facteur de sensibilité à la température"
    },
    option: {
      PROCESS_COOLING: "Refroidissement de procédé",
      DATA_CENTER: "Centre de données",
      ComfortCooling: "Refroidissement de confort",
      MixedUse: "Usage mixte",
      ProcessDataCenter: "Procédés / Centre de données",
      Custom: "Personnalisé"
    },
    msg: {
      GeneratingDefaults: "Génération des valeurs par défaut...",
      RunningQuickCalculation: "Exécution du calcul rapide...",
      DataOverwriteWarning: "Avertissement d’écrasement des données",
      PendingResultChangesWarning: "Vous avez effectué des modifications sur la page de vérification. Veuillez lancer la génération de nouveaux résultats avant de continuer.",
      RegenerateDefaultsWarning: "La régénération des valeurs par défaut écrasera définitivement les données actuelles des graphiques de la page de vérification. Souhaitez-vous continuer ?",
      PeriodCanNotAllOffEveryBaseline: "La période ne peut pas être entièrement désactivée pour chaque référence."
    }
  }
}



// WEBPACK FOOTER //
// ./src/locale/index/fr.js